import React from "react";

export default function PageNotFound() {
    return (
        <div className="page-not-found">
            <img src="airdeska_logo.png" />
            <h1>404: Page Not found</h1>
        </div>
    )
}